<template>
  <el-dialog
    :title="info.title"
    :visible.sync="info.show"
    :close-on-click-modal="false"
    :lock-scroll="false"
    :modal="false"
    class="quitCoHost"
    width="650px"
  >
    <div class="content">
      <p>{{info.contentText}}</p>
      <p v-if="info.confirmText">{{$t('coHost.confirmText')}}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="cancel" @click="info.show = false">{{$t('leftPane.cancel')}}</el-button>
      <el-button class="primary" type="primary" @click="quit">{{$t('coordinationRoom.agree')}}</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: {
    info: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      show: true
    }
  },
  methods: {
    quit () {
      this.info.show = false
      this.$emit('quitCoHost')
    }
  }
}
</script>
<style lang="less" scoped>
.quitCoHost{
  background-color: rgba(0, 0, 0, 0.5);
  overflow-y: hidden;
}
/deep/.el-dialog {
  border-radius: 8px;
  .el-dialog__header {
    font-size: 18px;
    font-weight: 500;
    .el-dialog__headerbtn {
      z-index: 1;
      .el-dialog__close {
        font-size: 16px;
        color: #28282e;
        font-weight: bold;
      }
      &:hover .el-dialog__close {
        color: #33ab4f;
      }
    }
  }
  .el-dialog__body {
    border-top: 2px solid #f5f5f5 !important;
    margin: 0px 18px 24px 18px !important;
    padding: 18px 0 0 0 !important;
    word-break: keep-all;
    font-family: Helvetica Neue;
    .el-input {
      &.redBorder {
        border: 1px solid red;
        border-radius: 3px;

        .el-input__inner {
          border: none;
        }
      }

      .el-input__inner {
        background: #f2f1f1fa;
        border-radius: 4px 4px 0 0;
        height: 40px;
        line-height: 40px;
      }
    }
  }
  .el-dialog__footer {
    .dialog-footer {
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
    .cancel {
      background: none;
      border: none;
      color: #606266 !important;
      font-size: 14px;
    }
    .primary{
      background: #F6445A;
      border-color: #F6445A;
      color:  #FFFFFF;
      font-size: 14px;
    }
    .el-button {
      width: 85px;
      height: 36px;
      color: #fff;
      border-radius: 4px;
    }
  }
}
</style>
